const LifeCoverData = [
  { label: "10 Lacs", value: "1000000" },
  { label: "15 Lacs", value: "1500000" },
  { label: "20 Lacs", value: "2000000" },
  { label: "25 Lacs", value: "2500000" },
  { label: "30 Lacs", value: "3000000" },
  { label: "35 Lacs", value: "3500000" },
  { label: "40 Lacs", value: "4000000" },
  { label: "45 Lacs", value: "4500000" },
  { label: "50 Lacs", value: "5000000" },
  { label: "55 Lacs", value: "5500000" },
  { label: "60 Lacs", value: "6000000" },
  { label: "65 Lacs", value: "6500000" },
  { label: "70 Lacs", value: "7000000" },
  { label: "75 Lacs", value: "7500000" },
  { label: "80 Lacs", value: "8000000" },
  { label: "85 Lacs", value: "8500000" },
  { label: "90 Lacs", value: "9000000" },
  { label: "95 Lacs", value: "9500000" },
  { label: "1 Crore", value: "10000000" },
  { label: "1.5 Crore", value: "15000000" },
  { label: "2 Crore", value: "20000000" },
  { label: "2.5 Crore", value: "25000000" },
  { label: "3 Crore", value: "30000000" },
  { label: "3.5 Crore", value: "35000000" },
  { label: "4 Crore", value: "40000000" },
  { label: "4.5 Crore", value: "45000000" },
];

export default LifeCoverData;
